import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

export const Loader: React.FC<{ text: string; loading: boolean }> = ({ text, loading }) => {
  return (
    <div className="gen-layers-loader">
      {text} {loading ? <LoadingOutlined className="gen-layers-loader__icon" /> : null}
    </div>
  );
};
